import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDataLayerValue } from "../../../../DataLayer/DataLayer";
import Layout from "../../../../Layout";
import HeaderBread from "../../../../components/HeaderBread";
import CustomHeaderTitle from "../../../../components/constants/CustomHeaderTitle";
import EntertainmentRvcInput from "../../../../components/EntertainmentRvcInput";
import { getEntertainmentRvc } from "../../../../utils/ApiCalls/BackOffice/Entertainment";

const MANAGEMENT_PATH = "/shore/back-office/entertainment/management";

const EditEntertainmentRvc = () => {
  const params = useParams();
  const [rvc, setRvc] = useState({});
  const [, dispatch] = useDataLayerValue();

  const navigation = [
    { title: "Home", route: "/" },
    { title: "Entertainment Management", route: MANAGEMENT_PATH },
    { title: "Edit Revenue Center", route: `${MANAGEMENT_PATH}/edit` },
  ];

  useEffect(() => {
    getData(params?.id);
  }, [params]);

  const getData = async (id) => {
    dispatch({ type: "SET_LOADING", loading: true });
    const data = await getEntertainmentRvc(id);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else {
      setRvc(data);
    }
    dispatch({ type: "SET_LOADING", loading: false });
  };

  return (
    <Layout type={"update_per"} module_data={"Management"}>
      <CustomHeaderTitle title={"Edit Revenue Center"} />
      <HeaderBread navigation={navigation} title={"Edit Revenue Center"}></HeaderBread>
      {rvc?.isDeleted === 0 && (
        <div className="container-fluid">
          <div className="alert alert-secondary" role="alert">
            This record has been removed - showing a read-only view.
          </div>
        </div>
      )}
      {rvc && <EntertainmentRvcInput rvc={rvc} readOnly={rvc?.isDeleted === 0} />}
    </Layout>
  );
};

export default EditEntertainmentRvc;
